import React, { Component } from "react";
import { connect } from "react-redux";
import { isEqual } from "lodash";
import { injectIntl, FormattedMessage } from "react-intl";
import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";

import solA from "./img/solution-tube-a-gel-modal.svg";
import solB from "./img/solution-tube-b-gel-modal.svg";
import solC from "./img/solution-tube-c-gel-modal.svg";
import solD from "./img/solution-tube-d-gel-modal.svg";
import solE from "./img/solution-tube-e-gel-modal.svg";
import solF from "./img/solution-tube-f-gel-modal.svg";
import idealSolutionResults from "./img/ideal-solution-results.svg";

import "./style.scss";

const outerNameIndexMap = { A: 9, B: 10, C: 11, D: 12, E: 13, F: 14 };
const images = {
  solA: solA,
  solB: solB,
  solC: solC,
  solD: solD,
  solE: solE,
  solF: solF,
  idealSolutionResults: idealSolutionResults,
};

class ExperimentalDesign extends Component {
  constructor(props) {
    super(props);
  }
  getContentItemColorStyle = (solution) => {
    const colors = {
      "gRNA-a": "#4cb862",
      "gRNA-b": "#4cb862",
      "gRNA-c": "#4cb862",
      "CCR5 DNA": "#003e6b",
      "CAS9 Protein": "#d67774",
      "DNA Ladder": "#70615f",
      "Control gRNA": "#ef2d96",
      "10x DNA Cleavage Buffer": "#4cb862",
      Water: "#d0e0ff",
    };
    return colors[solution];
  };

  isCorrect = (tube, solutions) => {
    const map = {
      A: ["DNA Ladder"],
      B: ["CCR5 DNA", "10x DNA Cleavage Buffer"],
      C: [
        "Control gRNA",
        "CCR5 DNA",
        "CAS9 Protein",
        "10x DNA Cleavage Buffer",
      ],
      D: ["gRNA-a", "CCR5 DNA", "CAS9 Protein", "10x DNA Cleavage Buffer"],
      E: ["gRNA-b", "CCR5 DNA", "CAS9 Protein", "10x DNA Cleavage Buffer"],
      F: ["gRNA-c", "CCR5 DNA", "CAS9 Protein", "10x DNA Cleavage Buffer"],
    };

    return isEqual(Object.keys(solutions).sort(), map[tube].sort());
  };

  renderContentsList = (tube, source) => {
    //source = "ideal" if showing ideal data, not actual

    if (["A", "B", "C", "D", "E", "F"].includes(tube)) {
      //Choose between actual and ideal solution data
      let solutions = {};

      const idealSolutions = [
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {
          type: "A",
          solutions: {
            "DNA Ladder": 1,
          },
        },
        {
          type: "B",
          solutions: {
            "CCR5 DNA": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
        {
          type: "C",
          solutions: {
            "Control gRNA": 1,
            "CCR5 DNA": 1,
            "CAS9 Protein": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
        {
          type: "D",
          solutions: {
            "gRNA-a": 1,
            "CCR5 DNA": 1,
            "CAS9 Protein": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
        {
          type: "E",
          solutions: {
            "gRNA-b": 1,
            "CCR5 DNA": 1,
            "CAS9 Protein": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
        {
          type: "F",
          solutions: {
            "gRNA-c": 1,
            "CCR5 DNA": 1,
            "CAS9 Protein": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
      ];

      if (source === "ideal") {
        solutions = idealSolutions[outerNameIndexMap[tube]].solutions;
      } else {
        solutions = this.props.solutions[outerNameIndexMap[tube]].solutions;
      }

      const solutionList = [];

      for (const i in solutions) {
        const colorStyle = this.getContentItemColorStyle(i);

        solutionList.push(
          <div className="results-tooltip-item" key={i}>
            <div
              className="results-tooltip-item__text-color"
              style={{ backgroundColor: colorStyle }}
            ></div>
            <div className="results-tooltip-item__text">{i}</div>
          </div>
        );
      }

      return (
        <div
          className="tooltip-wrap"
          aria-label={
            solutionList.length > 0
              ? this.props.intl.formatMessage(
                  {
                    id: "Tube {tube} contains the following solutions:",
                    defaultMessage:
                      "Tube {tube} contains the following solutions:",
                    description: "",
                  },
                  {
                    tube: tube,
                  }
                )
              : this.props.intl.formatMessage(
                  {
                    id: "Tube {tube} is empty.",
                    defaultMessage: "Tube {tube} is empty.",
                    description: "",
                  },
                  { tube: tube }
                )
          }
          style={{ padding: solutionList.length > 0 ? "1px 0px" : "8px 0px" }}
        >
          {solutionList.length > 0 ? solutionList : "Empty"}
        </div>
      );
    } else {
      return "";
    }
  };

  buildSolutionBlock = (tube, showCorrect, source, showLabels) => {
    //tube = A,B,C,D,E,F
    //showCorrect = true/false - displays the correct label below
    //source = "ideal" if showing ideal data, not actual

    function getCorrect() {
      if (showCorrect !== null) {
        if (showCorrect) {
          return (
            <div className="solution-card-footer__label correct">
              <FormattedMessage
                id="Correct"
                defaultMessage="Correct"
                description=""
              />
            </div>
          );
        } else {
          return (
            <div className="solution-card-footer__label incorrect">
              <FormattedMessage
                id="Incorrect"
                defaultMessage="Incorrect"
                description=""
              />
            </div>
          );
        }
      } else {
        return null;
      }
    }

    return (
      <div>
        {showLabels === true ? this.renderContentsList(tube, source) : null}
        <div id="solution-card-footer-img" className="solution-card-footer">
          <img
            className="solution-card-footer__image"
            src={images["sol" + tube]}
            alt={this.props.intl.formatMessage(
              {
                id: "Tube {tube}",
                defaultMessage: "Tube {tube}",
                description: "",
              },
              { tube: tube }
            )}
          />
          {getCorrect()}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="table-wrapper">
        <h4 className="sub-panel-heading" style={{ marginTop: "0px" }}>
          <FormattedMessage
            id="Actual reagents"
            defaultMessage="Actual reagents"
            description=""
          />
        </h4>
        <div className="solution-card-container">
          <div className="solution-card-container__result solution-1">
            {this.buildSolutionBlock(
              "A",
              this.isCorrect("A", this.props.solutions[9].solutions),
              null,
              true
            )}
          </div>

          <div className="solution-card-container__result solution-2">
            {this.buildSolutionBlock(
              "B",
              this.isCorrect("B", this.props.solutions[10].solutions),
              null,
              true
            )}
          </div>

          <div className="solution-card-container__result solution-3">
            {this.buildSolutionBlock(
              "C",
              this.isCorrect("C", this.props.solutions[11].solutions),
              null,
              true
            )}
          </div>

          <div className="solution-card-container__result solution-4">
            {this.buildSolutionBlock(
              "D",
              this.isCorrect("D", this.props.solutions[12].solutions),
              null,
              true
            )}
          </div>

          <div className="solution-card-container__result solution-5">
            {this.buildSolutionBlock(
              "E",
              this.isCorrect("E", this.props.solutions[13].solutions),
              null,
              true
            )}
          </div>

          <div className="solution-card-container__result solution-6">
            {this.buildSolutionBlock(
              "F",
              this.isCorrect("F", this.props.solutions[14].solutions),
              null,
              true
            )}
          </div>
        </div>

        <div className="rounded-text-box" style={{ marginTop: "36px" }}>
          <FormattedMessage
            id="Any samples that are incorrect above are indicated with a label. You can compare these to the ideal reagents used in this experiment below to see where you made mistakes."
            defaultMessage="Any samples that are incorrect above are indicated with a label. You can compare these to the ideal reagents used in this experiment below to see where you made mistakes."
            description=""
          />
        </div>

        <h4 className="sub-panel-heading" style={{ marginBottom: "10px" }}>
          <FormattedMessage
            id="Ideal reagents"
            defaultMessage="Ideal reagents"
            description=""
          />
        </h4>

        <div className="solution-card-container">
          <div className="solution-card-container__result solution-1">
            {this.buildSolutionBlock("A", null, "ideal", true)}
          </div>

          <div className="solution-card-container__result solution-2">
            {this.buildSolutionBlock("B", null, "ideal", true)}
          </div>

          <div className="solution-card-container__result solution-3">
            {this.buildSolutionBlock("C", null, "ideal", true)}
          </div>

          <div className="solution-card-container__result solution-4">
            {this.buildSolutionBlock("D", null, "ideal", true)}
          </div>

          <div className="solution-card-container__result solution-5">
            {this.buildSolutionBlock("E", null, "ideal", true)}
          </div>

          <div className="solution-card-container__result solution-6">
            {this.buildSolutionBlock("F", null, "ideal", true)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    solutions: state.solutions,
  };
};

const ExperimentalDesignWithIntl = injectIntl(ExperimentalDesign);

export const AssayExperimentalDesign = connect(
  mapStateToProps,
  {}
)((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <ExperimentalDesignWithIntl {...props} />
  </TranslationsProvider>
));
